import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Box, Grid, Paper, CircularProgress } from '@material-ui/core';

import { APP_SCENE, ROLE } from '../../../constants';

import HoSoNote from '../../../containers/KVC/HoSo/HoSoNote';
import HoSoDetail from '../../../containers/KVC/HoSo/HoSoDetail';

export default function HoSo() {
	const role = useSelector(state => state.userReducer.user?.role);
	const loading = useSelector(state => state.formReducer.loading);

	const isSuperAdmin = useMemo(() => {
    const adminRole = APP_SCENE.toLowerCase() + '_admin_';
    return role === ROLE.SUPER_ADMIN || role?.includes(adminRole);
  }, [role]);

	if (!role || loading) {
    return (
      <Box
        display='flex'
        alignItems='center'
        flexDirection='column'
        justifyContent='center'
        height='calc(100vh - 64px)'
      >
        <CircularProgress />
      </Box>
    );
  }

	// Admin chấm hồ sơ: bố cục 2 cột — Chi tiết hồ sơ (trái, cuộn) + box Chấm điểm
	// (phải, dính/sticky khi cuộn) giống Quả Cầu Vàng.
	if (isSuperAdmin) {
		return (
			<Grid item xs={12}>
				<Grid container spacing={3}>
					<Grid item xs={12} lg={9}>
						<Paper className='paper' style={{ marginTop: 32, marginBottom: 16 }}>
							<HoSoDetail isSuperAdmin={isSuperAdmin} />
						</Paper>
					</Grid>
					<Grid item xs={12} lg={3}>
						<Box
							style={{
								position: 'sticky',
								top: 80,
								marginTop: 32,
								maxHeight: 'calc(100vh - 96px)',
								overflowY: 'auto',
							}}
						>
							<HoSoNote />
						</Box>
					</Grid>
				</Grid>
			</Grid>
		);
	}

	// Ứng viên xem: 1 cột.
	return (
		<Box sx={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
			<Paper className='paper' style={{ marginTop: 32, marginBottom: 16 }}>
				<HoSoDetail isSuperAdmin={isSuperAdmin} />
			</Paper>
		</Box>
	)
}
